/* ewd-compatibles.js: panel del menu "Compatibles" (opcion 2 de la maqueta de Juande, 17/07/2026).
   Desarrollo propio de eWheel, no de Upango. Torre: pendiente 524, accion 1504.
   Pasos: tipo de vehiculo -> marca -> modelo -> familia -> subfamilia. Los datos de familias y la
   vista previa de productos salen de la coleccion del modelo (?section_id=ewd-compat-datos). */
(function () {
  'use strict';

  var TXT = {
    es: { marca: 'Elige la marca', modelo: 'Elige el modelo', recambio: 'Elige el recambio', buscar: 'Buscar marca',
      buscarModelo: 'Buscar modelo', alfa: 'Modelos por orden alfabético', todos: 'Ver todos los recambios de este modelo',
      verN: 'Ver los {n} recambios', verUno: 'Ver el recambio', sinMarca: 'Elige primero una marca', sinModelo: 'Elige tu modelo para ver sus recambios',
      sinPrecio: 'Inicia sesión para ver precios', nada: 'Sin resultados', proximo: 'Próximamente', cargando: 'Cargando…',
      desde: 'Desde', tipos: { patinete: 'Patinete', ebike: 'eBike', movilidad: 'Movilidad', moto: 'Moto' }, todas: 'Todas' },
    en: { marca: 'Choose the brand', modelo: 'Choose the model', recambio: 'Choose the spare part', buscar: 'Search brand',
      buscarModelo: 'Search model', alfa: 'Models in alphabetical order', todos: 'See all spare parts for this model',
      verN: 'See the {n} spare parts', verUno: 'See the spare part', sinMarca: 'Choose a brand first', sinModelo: 'Choose your model to see its spare parts',
      sinPrecio: 'Log in to see prices', nada: 'No results', proximo: 'Coming soon', cargando: 'Loading…',
      desde: 'From', tipos: { patinete: 'Scooter', ebike: 'eBike', movilidad: 'Mobility', moto: 'Motorbike' }, todas: 'All' },
    fr: { marca: 'Choisissez la marque', modelo: 'Choisissez le modèle', recambio: 'Choisissez la pièce', buscar: 'Rechercher une marque',
      buscarModelo: 'Rechercher un modèle', alfa: 'Modèles par ordre alphabétique', todos: 'Voir toutes les pièces de ce modèle',
      verN: 'Voir les {n} pièces', verUno: 'Voir la pièce', sinMarca: 'Choisissez d’abord une marque', sinModelo: 'Choisissez votre modèle pour voir ses pièces',
      sinPrecio: 'Connectez-vous pour voir les prix', nada: 'Aucun résultat', proximo: 'Bientôt', cargando: 'Chargement…',
      desde: 'À partir de', tipos: { patinete: 'Trottinette', ebike: 'Vélo électrique', movilidad: 'Mobilité', moto: 'Moto' }, todas: 'Toutes' },
    pt: { marca: 'Escolha a marca', modelo: 'Escolha o modelo', recambio: 'Escolha a peça', buscar: 'Procurar marca',
      buscarModelo: 'Procurar modelo', alfa: 'Modelos por ordem alfabética', todos: 'Ver todas as peças deste modelo',
      verN: 'Ver as {n} peças', verUno: 'Ver a peça', sinMarca: 'Escolha primeiro uma marca', sinModelo: 'Escolha o seu modelo para ver as peças',
      sinPrecio: 'Inicie sessão para ver os preços', nada: 'Sem resultados', proximo: 'Em breve', cargando: 'A carregar…',
      desde: 'Desde', tipos: { patinete: 'Trotinete', ebike: 'eBike', movilidad: 'Mobilidade', moto: 'Mota' }, todas: 'Todas' },
    it: { marca: 'Scegli la marca', modelo: 'Scegli il modello', recambio: 'Scegli il ricambio', buscar: 'Cerca marca',
      buscarModelo: 'Cerca modello', alfa: 'Modelli in ordine alfabetico', todos: 'Vedi tutti i ricambi di questo modello',
      verN: 'Vedi i {n} ricambi', verUno: 'Vedi il ricambio', sinMarca: 'Scegli prima una marca', sinModelo: 'Scegli il tuo modello per vedere i ricambi',
      sinPrecio: 'Accedi per vedere i prezzi', nada: 'Nessun risultato', proximo: 'Prossimamente', cargando: 'Caricamento…',
      desde: 'Da', tipos: { patinete: 'Monopattino', ebike: 'eBike', movilidad: 'Mobilità', moto: 'Moto' }, todas: 'Tutte' },
    de: { marca: 'Marke wählen', modelo: 'Modell wählen', recambio: 'Ersatzteil wählen', buscar: 'Marke suchen',
      buscarModelo: 'Modell suchen', alfa: 'Modelle alphabetisch', todos: 'Alle Ersatzteile für dieses Modell',
      verN: 'Die {n} Ersatzteile ansehen', verUno: 'Das Ersatzteil ansehen', sinMarca: 'Wähle zuerst eine Marke', sinModelo: 'Wähle dein Modell, um die Ersatzteile zu sehen',
      sinPrecio: 'Anmelden, um Preise zu sehen', nada: 'Keine Ergebnisse', proximo: 'Demnächst', cargando: 'Wird geladen…',
      desde: 'Ab', tipos: { patinete: 'E-Scooter', ebike: 'E-Bike', movilidad: 'Mobilität', moto: 'Motorrad' }, todas: 'Alle' },
    pl: { marca: 'Wybierz markę', modelo: 'Wybierz model', recambio: 'Wybierz część', buscar: 'Szukaj marki',
      buscarModelo: 'Szukaj modelu', alfa: 'Modele alfabetycznie', todos: 'Zobacz wszystkie części do tego modelu',
      verN: 'Zobacz {n} części', verUno: 'Zobacz część', sinMarca: 'Najpierw wybierz markę', sinModelo: 'Wybierz model, aby zobaczyć części',
      sinPrecio: 'Zaloguj się, aby zobaczyć ceny', nada: 'Brak wyników', proximo: 'Wkrótce', cargando: 'Ładowanie…',
      desde: 'Od', tipos: { patinete: 'Hulajnoga', ebike: 'Rower elektryczny', movilidad: 'Mobilność', moto: 'Motocykl' }, todas: 'Wszystkie' }
  };

  var SVG = {
    patinete: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M40 8h7M44 8l-6 36H22"/><circle cx="14" cy="48" r="6"/><circle cx="50" cy="48" r="6"/><path d="M38 44l12 4"/></svg>',
    ebike: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="14" cy="42" r="10"/><circle cx="50" cy="42" r="10"/><path d="M14 42l10-18h18l8 18M24 24l8 18h10M40 16h6l-4 8M22 18h8"/><rect x="26" y="27" width="10" height="5" rx="1"/></svg>',
    movilidad: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="16" cy="48" r="6"/><circle cx="48" cy="48" r="6"/><path d="M22 48h20M20 40h28l-4-12M24 40V22h10v10h-10M44 28l4-14h6"/></svg>',
    moto: '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><circle cx="13" cy="44" r="9"/><circle cx="51" cy="44" r="9"/><path d="M13 44l12-12h14l12 12M25 32l6-8h10l4-6h6M35 32l-4 12h8"/></svg>',
    flechaI: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>',
    flechaD: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    ok: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="11" fill="#5cb85c"/><path d="M7 12.5l3 3 7-7" fill="none" stroke="#fff" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    lupa: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M20 20l-4-4"/></svg>',
    mini: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h3M16.5 3L14 18H8"/><circle cx="6" cy="19" r="2"/><circle cx="19" cy="19" r="2"/></svg>'
  };

  /* Iconos de familia por palabra clave (cubre los nombres de Sage en los idiomas de la tienda). */
  var FAM_ICONOS = [
    [/rueda|neum|wheel|tyre|tire|roue|pneu|ruota|rad|koł/i, '<circle cx="24" cy="24" r="17"/><circle cx="24" cy="24" r="6"/><path d="M24 7v11M24 30v11M7 24h11M30 24h11M12 12l8 8M28 28l8 8M36 12l-8 8M20 28l-8 8"/>'],
    [/bater|batt|akku/i, '<rect x="15" y="9" width="18" height="33" rx="3"/><path d="M20 5h8M19 17h10M19 23h10M19 29h10M19 35h10"/>'],
    [/fren|brake|frein|freni|bremse|hamul/i, '<circle cx="22" cy="26" r="14"/><circle cx="22" cy="26" r="5"/><path d="M30 10c6 2 10 7 11 13l-6 2c-1-4-3-7-7-9z"/>'],
    [/carg|charg|carica|lade|ładow/i, '<rect x="13" y="16" width="16" height="24" rx="3"/><path d="M17 16v-5M25 16v-5M29 28h5a4 4 0 0 0 4-4V10M21 23l-3 6h5l-3 6"/>'],
    [/motor|moteur|motore/i, '<rect x="12" y="14" width="24" height="20" rx="2"/><path d="M6 20v8M42 20v8M17 14v20M22 14v20M27 14v20M32 14v20M12 24H6M36 24h6"/>'],
    [/electr|elektr/i, '<rect x="14" y="14" width="20" height="20" rx="2"/><rect x="19" y="19" width="10" height="10"/><path d="M19 9v5M24 9v5M29 9v5M19 34v5M24 34v5M29 34v5M9 19h5M9 24h5M9 29h5M34 19h5M34 24h5M34 29h5"/>'],
    [/mold|guardab|carenado|fairing|carros|carena|verkleid|osłon/i, '<path d="M6 30c4-12 14-18 26-18 5 0 9 1 11 3M10 30a14 14 0 0 1 28 0"/><circle cx="24" cy="30" r="5"/>'],
    [/horq|susp|fork|fourche|forcell|gabel|widel|amortig/i, '<path d="M18 6h12M20 6v14M28 6v14M17 20h14v4l-3 3v15M17 24l3 3v15"/><circle cx="24" cy="42" r="2"/>'],
    [/mecán|mecan|mechan|mécan|meccan|mechanik/i, '<path d="M12 36l14-14M29 9a7 7 0 0 0 9 9l-5 5-9-9zM10 34l4 4-3 3a3 3 0 0 1-4-4z"/>'],
    [/ilumin|luz|luces|light|éclair|luci|beleucht|oświet/i, '<path d="M20 12h-6a12 12 0 0 0 0 24h6zM26 14l14-4M26 20h15M26 26h15M26 32l14 4"/>'],
    [/puñ|grip|poign|manop|griff|chwyt/i, '<rect x="9" y="19" width="30" height="10" rx="5"/><path d="M15 19v10M21 19v10M27 19v10M33 19v10"/>'],
    [/acces|zubeh|akces/i, '<circle cx="24" cy="24" r="16"/><path d="M24 15v18M15 24h18"/>']
  ];
  var FAM_DEF = '<rect x="10" y="10" width="28" height="28" rx="4"/><path d="M17 24h14M24 17v14"/>';

  function famIcono(nombre) {
    for (var i = 0; i < FAM_ICONOS.length; i++) if (FAM_ICONOS[i][0].test(nombre)) return wrap(FAM_ICONOS[i][1]);
    return wrap(FAM_DEF);
    function wrap(p) { return '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>'; }
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function handleDe(u) { var m = /\/collections\/([^/?#]+)/.exec(u || ''); return m ? m[1] : ''; }
  function guardar(k, v) { try { localStorage.setItem('ewdCp.' + k, JSON.stringify(v)); } catch (e) { /* sin almacenamiento */ } }
  function leer(k) { try { return JSON.parse(localStorage.getItem('ewdCp.' + k)); } catch (e) { return null; } }

  /* El arbol (Argos) se pide la primera vez que el cliente pasa por "Compatibles", no en cada pagina. */
  function iniciar(raiz) {
    if (raiz.dataset.ewdCpListo) return;
    raiz.dataset.ewdCpListo = '1';
    var disparo = raiz.closest('li') || raiz.parentNode;
    var pedido = false;
    function cargar() {
      if (pedido) return;
      pedido = true;
      var clave = 'ewdCp.arbol.' + raiz.dataset.arbol;
      var guardado = null;
      try { guardado = JSON.parse(sessionStorage.getItem(clave)); } catch (e) { guardado = null; }
      if (guardado && guardado.marcas) { montar(raiz, guardado); return; }
      fetch(raiz.dataset.arbol).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (t) {
          try { sessionStorage.setItem(clave, t); } catch (e) { /* sin almacenamiento */ }
          montar(raiz, JSON.parse(t));
        })
        .catch(function () { pedido = false; });
    }
    ['mouseenter', 'focusin', 'touchstart', 'click'].forEach(function (ev) { disparo.addEventListener(ev, cargar, { passive: true }); });
    /* Se precarga cuando la pagina queda en reposo, para que al pasar por "Compatibles" ya este listo. */
    if (window.matchMedia && window.matchMedia('(min-width: 801px)').matches) {
      (window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); })(cargar, { timeout: 3000 });
    }
  }

  function montar(raiz, datos) {
    var loc = (raiz.dataset.locale || 'es').slice(0, 2);
    var T = TXT[loc] || TXT.es;
    var logueado = raiz.dataset.logged === '1';
    var app = raiz.querySelector('[data-ewd-cp-app]');

    /* Arbol de Argos: { marcas: [{ t, h, m: [{ t, c (sin la marca), h, n (recambios compatibles), tipo }] }] }.
       La URL de cada marca y modelo es su coleccion; la imagen se pide a la coleccion cuando se ve. */
    var base = (raiz.dataset.raiz || '/').replace(/\/?$/, '/');
    var infoCache = {};
    /* Si el arbol trae la imagen y si la coleccion existe (cdn presente), no hace falta pedirlo a la tienda. */
    function conocer(u, n) {
      if (datos.cdn) infoCache[u] = Promise.resolve({ existe: n.x !== 0, img: n.img ? (/^https?:/.test(n.img) ? n.img : datos.cdn + n.img) : null });
    }
    var marcas = (datos.marcas || []).map(function (m) {
      var modelos = (m.m || []).map(function (o) {
        /* Sin la marca delante, un modelo que se queda en un numero ("Dualtron 2" -> "2") se ve raro: entonces va el nombre completo. */
        var corto = o.c && !/^\d/.test(o.c) ? o.c : o.t;
        var mo = { t: o.t, c: corto, h: o.h, u: base + 'collections/' + o.h, n: o.n || 0, tipo: o.tipo || 'patinete', x: o.x };
        conocer(mo.u, o);
        return mo;
      }).sort(function (a, b) { return a.c.localeCompare(b.c, undefined, { numeric: true, sensitivity: 'base' }); });
      var ma = { t: m.t, h: m.h, u: base + 'collections/' + m.h, n: modelos.reduce(function (s, o) { return s + o.n; }, 0), m: modelos };
      conocer(ma.u, m);
      return ma;
    });

    function infoColeccion(u) {
      if (!infoCache[u]) {
        infoCache[u] = fetch(u + '.json', { credentials: 'same-origin' }).then(function (r) {
          if (r.status === 404) return { existe: false, img: null };
          return r.ok ? r.json().then(function (j) { var c = j.collection || {}; return { existe: true, img: c.image ? c.image.src : null }; }) : { existe: true, img: null };
        }).catch(function () { return { existe: true, img: null }; });
      }
      return infoCache[u];
    }
    function conAncho(src, w) { return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
    function cargarImagenes() {
      [].forEach.call(app.querySelectorAll('[data-img-u]'), function (el) {
        infoColeccion(el.getAttribute('data-img-u')).then(function (i) {
          if (!i.img || !el.isConnected) return;
          el.innerHTML = '<img src="' + esc(conAncho(i.img, el.getAttribute('data-img-w') || 240)) + '" alt="" loading="lazy">';
          el.classList.add('con-img');
        });
      });
    }

    var st = { tipo: 'patinete', marca: null, modelo: null, fam: null, sub: null, qMarca: '', qModelo: '', pag: 0, abierto: false };
    var ult = leer('ultimo');
    if (ult) {
      var mm = marcas.filter(function (m) { return m.t === ult.marca; })[0];
      if (mm) {
        st.marca = mm;
        st.modelo = mm.m.filter(function (o) { return o.u === ult.modelo; })[0] || null;
        if (st.modelo) st.tipo = st.modelo.tipo;
      }
    }

    function marcasDelTipo(tipo) {
      return marcas.filter(function (m) {
        return m.m.length ? m.m.some(function (o) { return o.tipo === tipo; }) : tipo === 'patinete';
      }).sort(function (a, b) { return b.m.length - a.m.length || b.n - a.n || a.t.localeCompare(b.t); });
    }
    function modelosDe(marca) { return marca ? marca.m.filter(function (o) { return o.tipo === st.tipo; }) : []; }

    var cache = {};
    function pedir(url) {
      if (cache[url]) return cache[url];
      cache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function (html) {
        var m = /<script type="application\/json" data-ewd-cp-datos>([\s\S]*?)<\/script>/.exec(html);
        if (!m) throw new Error('sin datos');
        return JSON.parse(m[1]);
      }).catch(function (e) { delete cache[url]; throw e; });
      return cache[url];
    }
    function urlPara(dest, fam, sub, conSeccion) {
      var q = [];
      if (conSeccion) q.push('section_id=ewd-compat-datos');
      if (fam && st.famParam) q.push(encodeURIComponent(st.famParam) + '=' + encodeURIComponent(fam));
      if (sub && st.subParam) q.push(encodeURIComponent(st.subParam) + '=' + encodeURIComponent(sub));
      return dest + (q.length ? (dest.indexOf('?') >= 0 ? '&' : '?') + q.join('&') : '');
    }
    function urlDatos(conSeccion) { return urlPara(st.modelo ? st.modelo.u : st.marca.u, st.fam, st.sub, conSeccion); }
    /* Peticion adelantada: al pasar el raton por un modelo, una familia o una subfamilia se piden ya sus datos,
       asi al hacer clic suelen estar en la cache. */
    function nada() {}
    app.addEventListener('mouseover', function (ev) {
      var b = ev.target.closest && ev.target.closest('[data-modelo], .ewd-cp__fam, .ewd-cp__sub');
      if (!b || b.__ewdPre) return;
      b.__ewdPre = 1;
      if (b.dataset.modelo) {
        var o = st.marca && st.marca.m.filter(function (x) { return x.u === b.dataset.modelo; })[0];
        if (o && o.x !== 0) pedir(urlPara(o.u, null, null, true)).catch(nada);
      } else if (b.classList.contains('ewd-cp__fam') && st.modelo) {
        pedir(urlPara(st.modelo.u, b.dataset.fam, null, true)).catch(nada);
      } else if (b.classList.contains('ewd-cp__sub') && st.modelo) {
        pedir(urlPara(st.modelo.u, st.fam, b.dataset.sub, true)).catch(nada);
      }
    });

    /* ---------- pintado ---------- */
    function pintar() {
      var lista = marcasDelTipo(st.tipo);
      var q = norm(st.qMarca);
      if (q) lista = lista.filter(function (m) { return norm(m.t).indexOf(q) >= 0; });
      var porPag = 5;
      var paginas = Math.max(1, Math.ceil(lista.length / porPag));
      if (st.pag >= paginas) st.pag = paginas - 1;
      if (st.pag < 0) st.pag = 0;
      var visibles = lista.slice(st.pag * porPag, st.pag * porPag + porPag);

      var h = '';
      h += '<div class="ewd-cp__tipos" role="tablist">';
      /* Solo los tipos de vehiculo con compatibilidades en Argos (JA 19/10: movilidad y moto fuera mientras no tengan). */
      ['patinete', 'ebike', 'movilidad', 'moto'].forEach(function (t) {
        if (!marcasDelTipo(t).length) return;
        h += '<button type="button" role="tab" class="ewd-cp__tipo' + (st.tipo === t ? ' is-on' : '') + '" data-tipo="' + t + '"' +
          ' aria-selected="' + (st.tipo === t) + '" title="' + esc(T.tipos[t]) + '">' + SVG[t] + '<span>' + esc(T.tipos[t]) + '</span></button>';
      });
      h += '</div>';

      h += '<div class="ewd-cp__fila">';
      /* Marca */
      h += '<section class="ewd-cp__bloque ewd-cp__marcas"><h3 class="ewd-cp__tit">' + esc(T.marca) + '</h3>';
      h += '<div class="ewd-cp__carrusel">';
      h += '<button type="button" class="ewd-cp__flecha" data-pag="-1" aria-label="&lt;"' + (st.pag > 0 ? '' : ' disabled') + '>' + SVG.flechaI + '</button>';
      h += '<div class="ewd-cp__marcas-lista">';
      if (!visibles.length) h += '<p class="ewd-cp__vacio">' + esc(T.nada) + '</p>';
      visibles.forEach(function (m) {
        var on = st.marca && st.marca.t === m.t;
        h += '<button type="button" class="ewd-cp__marca' + (on ? ' is-on' : '') + '" data-marca="' + esc(m.t) + '">' +
          (on ? '<i class="ewd-cp__ok">' + SVG.ok + '</i>' : '') +
          '<span class="ewd-cp__logo" data-img-u="' + esc(m.u) + '" data-img-w="240"><b>' + esc(m.t) + '</b></span>' +
          '<span class="ewd-cp__nombre">' + esc(m.t) + '</span></button>';
      });
      h += '</div>';
      h += '<button type="button" class="ewd-cp__flecha" data-pag="1" aria-label="&gt;"' + (st.pag < paginas - 1 ? '' : ' disabled') + '>' + SVG.flechaD + '</button>';
      h += '</div>';
      h += '<label class="ewd-cp__buscar">' + SVG.lupa + '<input type="search" data-q="marca" placeholder="' + esc(T.buscar) + '" value="' + esc(st.qMarca) + '" autocomplete="off"></label>';
      h += '</section>';

      /* Modelo */
      h += '<section class="ewd-cp__bloque ewd-cp__modelos"><h3 class="ewd-cp__tit">' + esc(T.modelo) + '</h3>';
      h += '<div class="ewd-cp__modelo-fila">';
      h += '<div class="ewd-cp__foto"' + (st.modelo ? ' data-img-u="' + esc(st.modelo.u) + '" data-img-w="480"' : '') + '><span class="ewd-cp__foto-vacia">' + SVG[st.tipo] + '</span><i class="ewd-cp__peana"></i></div>';
      h += '<div class="ewd-cp__selector">';
      if (!st.marca) {
        h += '<p class="ewd-cp__aviso">' + esc(T.sinMarca) + '</p>';
      } else {
        var mods = modelosDe(st.marca);
        h += '<div class="ewd-cp__combo' + (st.abierto ? ' is-open' : '') + '">';
        h += '<label class="ewd-cp__buscar">' + SVG.lupa + '<input type="search" data-q="modelo" placeholder="' + esc(st.modelo ? st.modelo.c : T.buscarModelo) + '" value="' + esc(st.qModelo) + '" autocomplete="off" aria-expanded="' + st.abierto + '"></label>';
        h += '<div class="ewd-cp__desplegable" role="listbox">' + listaModelos(mods) + '</div>';
        h += '</div>';
        if (!st.abierto) {
          /* Accesos rapidos: el elegido y los que mas recambios tienen */
          var rapidos = mods.slice().sort(function (a, b) { return b.n - a.n; }).slice(0, 3);
          if (st.modelo && rapidos.indexOf(st.modelo) < 0) rapidos = [st.modelo].concat(rapidos.slice(0, 2));
          h += '<div class="ewd-cp__rapidos">';
          rapidos.forEach(function (o) {
            var on = st.modelo === o;
            h += '<button type="button" class="ewd-cp__rapido' + (on ? ' is-on' : '') + '" data-modelo="' + esc(o.u) + '">' + SVG.mini + '<span>' + esc(o.c) + '</span>' + (on ? '<i class="ewd-cp__ok">' + SVG.ok + '</i>' : '') + '</button>';
          });
          if (!mods.length) h += '<a class="ewd-cp__rapido" href="' + esc(st.marca.u) + '">' + esc(T.todos) + '</a>';
          h += '</div>';
        }
      }
      h += '</div></div></section>';
      h += '</div>';

      /* Recambio */
      h += '<section class="ewd-cp__bloque ewd-cp__recambio"><h3 class="ewd-cp__tit">' + esc(T.recambio) + '</h3>';
      if (!st.modelo) {
        h += '<p class="ewd-cp__aviso ewd-cp__aviso--centro">' + esc(T.sinModelo) + '</p>';
      } else {
        h += '<div class="ewd-cp__rec-fila">';
        h += '<div class="ewd-cp__familias"><a class="ewd-cp__btn" href="' + esc(st.modelo.u) + '">' + esc(T.todos) + '</a><div class="ewd-cp__fam-grid" data-fam-grid><p class="ewd-cp__aviso">' + esc(T.cargando) + '</p></div></div>';
        h += '<div class="ewd-cp__subs" data-subs></div>';
        h += '<div class="ewd-cp__prods" data-prods></div>';
        h += '</div>';
      }
      h += '</section>';

      app.innerHTML = h;
      cargarImagenes();
      if (st.modelo) cargarDatos();
      hueco();
    }

    /* El desplegable de modelos va por encima del panel; si sobresale por abajo, el mega-menu del tema (overflow auto) lo
       cortaba con su propia barra de scroll (JA 20/10/2026, pantallas grandes). Se reserva abajo el hueco que falta. */
    function hueco() {
      app.style.paddingBottom = '';
      var des = st.abierto && app.querySelector('.ewd-cp__desplegable');
      if (!des || !des.offsetHeight) return;
      var caja = raiz.closest('.main-nav__child') || app;
      var falta = des.getBoundingClientRect().bottom - caja.getBoundingClientRect().bottom + 12;
      if (falta > 0) app.style.paddingBottom = Math.ceil(falta) + 'px';
    }
    var menu = raiz.closest('details');
    if (menu) menu.addEventListener('toggle', hueco);

    function listaModelos(mods) {
      var q = norm(st.qModelo);
      var l = q ? mods.filter(function (o) { return norm(o.c).indexOf(q) >= 0 || norm(o.t).indexOf(q) >= 0; }) : mods;
      var h = '<p class="ewd-cp__des-tit">' + esc(T.alfa) + '</p>';
      if (!l.length) return h + '<p class="ewd-cp__vacio">' + esc(T.nada) + '</p>';
      l.forEach(function (o) {
        var on = st.modelo === o;
        h += '<button type="button" role="option" aria-selected="' + on + '" class="ewd-cp__opcion' + (on ? ' is-on' : '') + '" data-modelo="' + esc(o.u) + '">' + SVG.mini + '<span>' + esc(o.c) + '</span>' + (on ? '<i class="ewd-cp__ok">' + SVG.ok + '</i>' : '') + '</button>';
      });
      return h;
    }

    function cargarDatos() {
      var grid = app.querySelector('[data-fam-grid]');
      var subs = app.querySelector('[data-subs]');
      var prods = app.querySelector('[data-prods]');
      var modeloPedido = st.modelo;
      prods.innerHTML = '<p class="ewd-cp__aviso">' + esc(T.cargando) + '</p>';
      /* Las familias se piden sin filtro (para ver todas); subfamilias y productos con el filtro puesto. */
      var famSolo = st.fam, subSolo = st.sub;
      st.fam = null; st.sub = null;
      var urlBase = urlDatos(true);
      st.fam = famSolo; st.sub = subSolo;
      infoColeccion(st.modelo.u).then(function (i) {
        if (i.existe || modeloPedido !== st.modelo) return;
        grid.innerHTML = '';
        prods.innerHTML = '<a class="ewd-cp__btn ewd-cp__btn--linea" href="' + esc(base + 'search?q=' + encodeURIComponent(st.modelo.t)) + '">' + esc(T.todos) + '</a>';
        throw new Error('sin coleccion');
      }).then(function () { return pedir(urlBase); }).then(function (base) {
        if (modeloPedido !== st.modelo) return;
        if (base.fam) st.famParam = base.fam.p;
        if (base.sub) st.subParam = base.sub.p;
        pintarFamilias(grid, base);
        return (st.fam || st.sub ? pedir(urlDatos(true)) : Promise.resolve(base)).then(function (d) {
          if (modeloPedido !== st.modelo) return;
          if (d.sub) st.subParam = d.sub.p;
          pintarSubs(subs, st.fam ? d : null);
          pintarProductos(prods, d);
        });
      }).catch(function () {
        grid.innerHTML = '';
        prods.innerHTML = '<a class="ewd-cp__btn ewd-cp__btn--linea" href="' + esc(st.modelo.u) + '">' + esc(T.todos) + '</a>';
      });
    }

    function pintarFamilias(grid, d) {
      if (!d.fam || !d.fam.v.length) { grid.innerHTML = ''; return; }
      var h = '';
      d.fam.v.forEach(function (v) {
        var on = st.fam === v.v;
        h += '<button type="button" class="ewd-cp__fam' + (on ? ' is-on' : '') + '" data-fam="' + esc(v.v) + '" title="' + esc(v.l) + ' (' + v.c + ')">' +
          (on ? '<i class="ewd-cp__ok">' + SVG.ok + '</i>' : '') + '<span class="ewd-cp__fam-ico">' + famIcono(v.l) + '</span><span class="ewd-cp__fam-txt">' + esc(v.l) + '</span></button>';
      });
      grid.innerHTML = h;
    }

    function pintarSubs(cont, d) {
      if (!d || !d.sub || !d.sub.v.length) { cont.innerHTML = ''; cont.classList.remove('is-on'); return; }
      cont.classList.add('is-on');
      var h = '<div class="ewd-cp__subs-lista">';
      d.sub.v.forEach(function (v) {
        if (!v.c && st.sub !== v.v) return;
        var on = st.sub === v.v;
        h += '<button type="button" class="ewd-cp__sub' + (on ? ' is-on' : '') + '" data-sub="' + esc(v.v) + '"><span>' + esc(v.l) + '</span>' + (on ? '<i class="ewd-cp__ok">' + SVG.ok + '</i>' : '<small>' + v.c + '</small>') + '</button>';
      });
      cont.innerHTML = h + '</div>';
    }

    function pintarProductos(cont, d) {
      if (!d.prod.length) { cont.innerHTML = '<p class="ewd-cp__vacio">' + esc(T.nada) + '</p>'; return; }
      var h = '<div class="ewd-cp__prods-fila">';
      h += '<button type="button" class="ewd-cp__flecha" data-desliza="-1" aria-label="&lt;">' + SVG.flechaI + '</button>';
      h += '<div class="ewd-cp__prods-lista" data-prods-lista>';
      d.prod.forEach(function (p) {
        h += '<a class="ewd-cp__prod" href="' + esc(p.u) + '"><span class="ewd-cp__prod-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '') + '</span>' +
          '<span class="ewd-cp__prod-tit">' + esc(p.t) + '</span>' +
          (p.pr ? '<span class="ewd-cp__prod-pr">' + (p.pv ? esc(T.desde) + ' ' : '') + esc(p.pr) + '</span>' : '') + '</a>';
      });
      h += '</div><button type="button" class="ewd-cp__flecha" data-desliza="1" aria-label="&gt;">' + SVG.flechaD + '</button></div>';
      h += '<a class="ewd-cp__btn ewd-cp__btn--ver" href="' + esc(urlDatos(false)) + '">' + esc(d.total === 1 ? T.verUno : T.verN.replace('{n}', d.total)) + '</a>';
      if (!logueado) h += '<p class="ewd-cp__nota">' + esc(T.sinPrecio) + '</p>';
      cont.innerHTML = h;
    }

    /* ---------- eventos ---------- */
    app.addEventListener('click', function (ev) {
      var b = ev.target.closest('button, a');
      if (!b || !app.contains(b)) return;
      if (b.tagName === 'BUTTON') ev.preventDefault();
      var d = b.dataset;
      if (d.tipo) {
        if (b.getAttribute('aria-disabled') === 'true' || d.tipo === st.tipo) return;
        st.tipo = d.tipo; st.marca = null; st.modelo = null; st.fam = null; st.sub = null; st.pag = 0; st.qModelo = ''; st.abierto = false;
        pintar();
      } else if (d.pag) {
        st.pag += +d.pag; pintar();
      } else if (d.marca) {
        var m = marcas.filter(function (x) { return x.t === d.marca; })[0];
        if (!m) return;
        if (st.marca !== m) { st.marca = m; st.modelo = null; st.fam = null; st.sub = null; st.qModelo = ''; }
        st.abierto = modelosDe(m).length > 0;
        pintar();
        var inp = app.querySelector('input[data-q="modelo"]');
        if (inp) inp.focus({ preventScroll: true });
      } else if (d.modelo) {
        var o = st.marca && st.marca.m.filter(function (x) { return x.u === d.modelo; })[0];
        if (!o) return;
        st.modelo = o; st.fam = null; st.sub = null; st.qModelo = ''; st.abierto = false;
        guardar('ultimo', { marca: st.marca.t, modelo: o.u });
        pintar();
      } else if (d.fam != null && b.classList.contains('ewd-cp__fam')) {
        st.fam = st.fam === d.fam ? null : d.fam; st.sub = null; cargarDatos();
      } else if (d.sub != null && b.classList.contains('ewd-cp__sub')) {
        st.sub = st.sub === d.sub ? null : d.sub; cargarDatos();
      } else if (d.desliza) {
        var l = app.querySelector('[data-prods-lista]');
        if (l) l.scrollBy({ left: (+d.desliza) * l.clientWidth * 0.8, behavior: 'smooth' });
      }
    });

    app.addEventListener('input', function (ev) {
      var i = ev.target;
      if (i.dataset.q === 'marca') {
        st.qMarca = i.value; st.pag = 0;
        var pos = i.selectionStart;
        pintar();
        var n = app.querySelector('input[data-q="marca"]');
        n.focus({ preventScroll: true }); n.setSelectionRange(pos, pos);
      } else if (i.dataset.q === 'modelo') {
        st.qModelo = i.value; st.abierto = true;
        var des = app.querySelector('.ewd-cp__desplegable');
        if (des) des.innerHTML = listaModelos(modelosDe(st.marca));
        hueco();
      }
    });
    app.addEventListener('focusin', function (ev) {
      if (ev.target.dataset && ev.target.dataset.q === 'modelo' && !st.abierto) {
        st.abierto = true;
        var c = app.querySelector('.ewd-cp__combo');
        if (c) c.classList.add('is-open');
        var r = app.querySelector('.ewd-cp__rapidos');
        if (r) r.hidden = true;
        hueco();
      }
    });
    app.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && st.abierto) { st.abierto = false; st.qModelo = ''; pintar(); }
      if (ev.key === 'Enter' && ev.target.dataset && ev.target.dataset.q) {
        ev.preventDefault();
        var primero = ev.target.dataset.q === 'marca' ? app.querySelector('.ewd-cp__marca') : app.querySelector('.ewd-cp__opcion');
        if (primero) primero.click();
      }
    });
    document.addEventListener('click', function (ev) {
      if (st.abierto && !ev.target.closest('.ewd-cp__combo') && !ev.target.closest('.ewd-cp__marca') && app.contains(app.querySelector('.ewd-cp__combo'))) {
        if (!app.contains(ev.target)) return;
        st.abierto = false; st.qModelo = ''; pintar();
      }
    });

    pintar();
  }

  function arrancar() { document.querySelectorAll('[data-ewd-cp]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
})();
